import { useEffect } from 'react';
import { SITE_URL, LOGO_URL } from '../../utils/siteConfig';

const buildSchemas = () => [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Direct Uit China',
    alternateName: ['DUC', 'Direct uit China'],
    url: SITE_URL,
    logo: {
      '@type': 'ImageObject',
      url: LOGO_URL,
      width: 800,
      height: 600,
    },
    foundingDate: '2025',
    founders: [{ '@type': 'Person', name: 'Shubam' }],
    description:
      'Direct Uit China (DUC) is een sourcing agent en importbemiddelaar die bedrijven en particulieren helpt met goedkoop inkopen uit China. Wij regelen product sourcing, private label productie, kwaliteitscontrole en DDP levering.',
    telephone: '+31624359162',
    email: 'Info@directuitchina.nl',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'NL',
      addressLocality: 'Nederland',
    },
    sameAs: [
      'https://www.instagram.com/directuitchina/',
      'http://linkedin.com/company/direct-uit-china',
    ],
    serviceType: [
      'Product Sourcing China',
      'Sourcing Agent Nederland',
      'Import uit China',
      'Private Label China',
      'DDP Levering',
      'Kwaliteitscontrole',
      'Inkoop bemiddeling China',
    ],
    areaServed: {
      '@type': 'Country',
      name: 'Netherlands',
    },
    knowsAbout: [
      'inkopen uit China',
      'sourcing agent China',
      'goedkoop inkopen',
      'product sourcing',
      'private label China',
      'import China',
      'DDP levering',
      'groothandel China',
    ],
    legalName: 'ROLGO',
    taxID: 'NL005197054B84',
    vatID: 'NL005197054B84',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${SITE_URL}/#business`,
    name: 'Direct Uit China (DUC)',
    description:
      'DUC is uw sourcing agent voor goedkoop inkopen uit China. Product sourcing, private label productie, kwaliteitscontrole en all-in DDP levering naar Nederland. Bespaar 30–80% op uw inkoopkosten.',
    url: SITE_URL,
    logo: LOGO_URL,
    image: LOGO_URL,
    telephone: '+31624359162',
    email: 'Info@directuitchina.nl',
    priceRange: '€€',
    currenciesAccepted: 'EUR',
    paymentAccepted: 'Bank Transfer',
    foundingDate: '2025',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'NL',
      addressLocality: 'Nederland',
    },
    areaServed: [
      { '@type': 'Country', name: 'Netherlands' },
      { '@type': 'Country', name: 'Belgium' },
    ],
    sameAs: [
      'https://www.instagram.com/directuitchina/',
      'http://linkedin.com/company/direct-uit-china',
    ],
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+31624359162',
      contactType: 'customer service',
      availableLanguage: ['Dutch', 'English'],
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'DUC Diensten',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Product Sourcing China', url: `${SITE_URL}/diensten/product-sourcing` } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Private Label China', url: `${SITE_URL}/private-label-china` } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'DDP Levering uit China', url: `${SITE_URL}/diensten/ddp-levering` } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Kwaliteitscontrole', url: `${SITE_URL}/diensten/productiebegeleiding` } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Sourcing Service', url: `${SITE_URL}/sourcing-service` } },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Direct Uit China (DUC)',
    url: SITE_URL,
    description:
      'Sourcing agent voor goedkoop inkopen uit China. Product sourcing, private label, DDP levering en importbemiddeling voor bedrijven en particulieren.',
    inLanguage: 'nl-NL',
    publisher: {
      '@type': 'Organization',
      name: 'Direct Uit China (DUC)',
    },
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/blog?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Sourcing Agent & Import Service China',
    provider: {
      '@type': 'Organization',
      name: 'Direct Uit China (DUC)',
      url: SITE_URL,
    },
    name: 'Inkopen uit China — Sourcing, Private Label & DDP Import',
    description:
      'DUC helpt bedrijven en particulieren direct inkopen bij fabrikanten in China. Wij regelen product sourcing, private label productie, kwaliteitscontrole en all-in DDP levering naar Nederland. Bespaar 30–80% op uw inkoopkosten.',
    url: `${SITE_URL}/sourcing-service`,
    areaServed: 'Netherlands',
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'DUC Diensten',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Product Sourcing China' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Private Label China' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'DDP Levering uit China' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Kwaliteitscontrole' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Inkoop bemiddeling China' } },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Hoe werkt inkopen uit China via DUC?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'U stuurt ons uw product of beschrijving, wij zoeken de beste fabriek, sturen binnen 24 uur een gratis prijsindicatie en regelen de volledige productie en DDP levering naar uw deur.',
        },
      },
      {
        '@type': 'Question',
        name: 'Hoeveel kan ik besparen door producten te importeren uit China?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Klanten besparen gemiddeld 30–80% ten opzichte van Nederlandse leveranciers. Dit komt doordat DUC direct bij fabrikanten inkoopt, zonder tussenhandelaren.',
        },
      },
      {
        '@type': 'Question',
        name: 'Wat is een sourcing agent en wat doet DUC?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Een sourcing agent is een tussenpersoon die voor u de beste fabriek zoekt in China, onderhandelt over prijs en kwaliteit, de productie begeleidt en de verzending regelt. DUC is uw Nederlandse sourcing agent voor inkopen uit China.',
        },
      },
      {
        '@type': 'Question',
        name: 'Wat is de minimale bestelhoeveelheid (MOQ) voor inkopen uit China?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'De MOQ verschilt per product. Voor veel producten starten we al vanaf 50 stuks. We zoeken altijd een fabriek die past bij uw volume en budget.',
        },
      },
      {
        '@type': 'Question',
        name: 'Zijn alle kosten inbegrepen bij DDP levering?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Ja. DDP (Delivered Duty Paid) betekent dat transport, invoerrechten en BTW allemaal inbegrepen zijn in de prijs. U betaalt één all-in bedrag, geen verrassingen achteraf.',
        },
      },
      {
        '@type': 'Question',
        name: 'Hoe snel krijg ik een prijsindicatie voor inkopen uit China?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Binnen 24 uur na uw aanvraag ontvangt u een eerste gratis en vrijblijvende prijsindicatie.',
        },
      },
      {
        '@type': 'Question',
        name: 'Kan ik producten met mijn eigen logo laten maken in China (private label)?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Absoluut. Private label en maatwerk is een van onze specialiteiten. Van uw logo op verpakkingen tot volledig custom producten — DUC regelt het volledige productietraject.',
        },
      },
      {
        '@type': 'Question',
        name: 'Wat zijn de risicos van inkopen uit China?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Risicos zijn er, maar DUC minimaliseert ze: wij werken alleen met geverifieerde fabrieken, voeren kwaliteitscontroles uit, regelen samplebeoordeling en begeleiden de volledige productie. We raden altijd aan eerst een sample te bestellen.',
        },
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'SiteLinksSearchBox',
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/blog?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
];

export default function GlobalSEO() {
  useEffect(() => {
    const schemas = buildSchemas();
    schemas.forEach((schema, i) => {
      const id = `global-structured-data-${i}`;
      let script = document.getElementById(id) as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    });

    return () => {
      schemas.forEach((_, i) => {
        const el = document.getElementById(`global-structured-data-${i}`);
        if (el) el.remove();
      });
    };
  }, []);

  return null;
}
